import { MitigationsCommands } from '../mitigation/commands';
import { TechniqueMitigationsCommands } from '../technique-mitigation/commands';
import { TacticsCommands } from '../tactic/commands';
import { TechniquesCommands } from '../technique/commands';
import { AssetTypesCommands } from '../asset-type/commands';
import { type AttckData, type AttckJSON } from './dto';
import { Attck } from './repository';

export class AttckCommands {
    assetTypesCommands: AssetTypesCommands;
    mitigationCommands: MitigationsCommands;
    tacticsCommands: TacticsCommands;
    techniquesCommands: TechniquesCommands;
    techniqueMitigationsCommands: TechniqueMitigationsCommands;

    constructor() {
        this.assetTypesCommands = new AssetTypesCommands();
        this.mitigationCommands = new MitigationsCommands();
        this.tacticsCommands = new TacticsCommands();
        this.techniquesCommands = new TechniquesCommands();
        this.techniqueMitigationsCommands = new TechniqueMitigationsCommands();
    }

    set(attck: Attck, data: AttckData): void {
        attck.setAttck({ id: data.id, version: data.version });
        this.assetTypesCommands.addAll(attck.assetTypes, data.assets);
        this.mitigationCommands.addAll(attck.mitigations, data.mitigations);
        this.tacticsCommands.addAll(attck.tactics, data.tactics);
        this.techniquesCommands.addAll(attck.techniques, data.techniques);
        this.techniqueMitigationsCommands.addAll(
            attck.techniqueMitigations,
            data.techniqueMitigations,
        );
    }

    fromJSON(attck: AttckJSON, changeCallback: () => void): Attck {
        const newAttck = new Attck(changeCallback);
        newAttck.id = attck.id;
        newAttck.version = attck.version;
        newAttck.assetTypes = this.assetTypesCommands.fromJSON(
            attck.assetTypes,
            changeCallback,
        );
        newAttck.mitigations = this.mitigationCommands.fromJSON(
            attck.mitigations,
            changeCallback,
        );
        newAttck.tactics = this.tacticsCommands.fromJSON(
            attck.tactics,
            changeCallback,
        );
        newAttck.techniques = this.techniquesCommands.fromJSON(
            attck.techniques,
            changeCallback,
        );
        newAttck.techniqueMitigations =
            this.techniqueMitigationsCommands.fromJSON(
                attck.techniqueMitigations,
                changeCallback,
            );
        return newAttck;
    }
}
